var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bottom_inner", style: _vm.getLayoutStyle },
    [
      _vm._l(_vm.tabBarList, function (bar, index) {
        return _c(
          "div",
          {
            key: index,
            class: [
              "tabBar",
              "tabBar_" + (bar.style || "1"),
              index === _vm.currentIndex && "current",
            ],
            on: {
              click: function ($event) {
                _vm.currentIndex = index
              },
            },
          },
          [
            bar.style === "3"
              ? [
                  _c(
                    "el-image",
                    {
                      staticClass: "icon",
                      attrs: {
                        fit: "contain",
                        src:
                          index === _vm.currentIndex
                            ? bar.active_imageurl
                            : bar.imageurl,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [_c("i", { staticClass: "el-icon-picture" })]
                      ),
                    ]
                  ),
                ]
              : [
                  _c(
                    "el-image",
                    {
                      staticClass: "icon",
                      attrs: {
                        src:
                          index === _vm.currentIndex
                            ? bar.active_imageurl
                            : bar.imageurl,
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [_c("i", { staticClass: "el-icon-picture" })]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "barName",
                      style: _vm.getNameStyle(bar, index),
                    },
                    [_vm._v(" " + _vm._s(bar.name_alias) + " ")]
                  ),
                ],
          ],
          2
        )
      }),
      _vm.info.category_id || _vm.canDel
        ? _c("i", {
            staticClass: "el-icon el-icon-close",
            on: {
              click: function ($event) {
                $event.stopPropagation()
                return _vm.removeLayout($event)
              },
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }